import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { cpbaseUrl } from "../../Constant/Matcher";

const getToken = () => {
    const userToken = JSON.parse(localStorage.getItem("userData"))
    return userToken ? `Bearer ${userToken.token}` : ''
}

export const channelPartnerProfile = createApi({
  reducerPath: "channelPartnerProfile",
  baseQuery: fetchBaseQuery({
    baseUrl: cpbaseUrl,
    mode: "cors",
    prepareHeaders: (headers) => {
        const token = getToken()
        if(token) {
            headers.set('Authorization', token)
        }
        return headers;
    }
  }),
  endpoints: (builder) => ({
    profile: builder.query({
        query: () => ({
         url: `profile`,
         method: "GET",
        })
     }),
  }),
});

export const { useProfileQuery } = channelPartnerProfile;
